import { useEffect } from "react";
import { onWs } from "../api/ws.js";
import { useSession } from "../state/session.js";
import { useAlliance } from "./state.js";

/** Keeps the alliance store fresh for badges: loads once per account and refreshes on alliance pushes (D71). */
export function useAlliancePushes(): void {
  const accountId = useSession((s) => s.account?.id);
  useEffect(() => {
    if (!accountId) return;
    void useAlliance.getState().refresh();
    const kinds = ["alliance.joined", "alliance.request", "alliance.invite", "alliance.role", "alliance.kicked", "alliance.disbanded", "alliance.declined", "alliance.diplomacy", "alliance.duel", "base.assist"];
    const offs = kinds.map((kind) => onWs(kind, () => void useAlliance.getState().refresh()));
    return () => {
      for (const off of offs) off();
    };
  }, [accountId]);
}
